import { styled } from "@mui/material/styles";
import React from "react";

import { useGetBenchmarkFilters } from "queries/query-selectors/benchmark-query-selectors";
import { AutocompleteMultiSelect } from "components/reports";
import { filterOptions } from "constants/benchmark";
import { ReportFilters } from "store/types";

interface Props {
  filters: ReportFilters;
  setFilters: (filters: ReportFilters) => void;
}

interface FilterFieldProps {
  isLoading: boolean;
  filterValues: ReportFilters;
  filters: Props["filters"];
  setFilters: Props["setFilters"];
  field: string;
  label: string;
}

const Wrapper = styled("div")({
  flexGrow: 1,
  flexShrink: 1,
  maxWidth: "13%",
  ".MuiOutlinedInput-root": {
    overflow: "hidden",
    flexWrap: "nowrap !important"
  }
});

const FilterField = ({ isLoading, filterValues, filters, setFilters, field, label }: FilterFieldProps) => {
  return (
    <Wrapper>
      <AutocompleteMultiSelect<true, false, false>
        multiple
        selectAll={false}
        fullWidth
        label={label}
        options={(filterValues[field] as string[]) || []}
        loading={isLoading}
        limitTags={1}
        value={(filters[field] as string[]) || []}
        onChange={(option) => {
          if (option?.length) {
            setFilters({ ...filters, [field]: option } as ReportFilters); // TS issue
          } else {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [field]: value, ...removed } = filters;
            setFilters(removed);
          }
        }}
      />
    </Wrapper>
  );
};

export const Filters: React.FC<Props> = ({ filters, setFilters }) => {
  const { data, isLoading } = useGetBenchmarkFilters(filters);
  const filterValues = data || {};

  return (
    <div className="benchmark__top-row">
      {filterOptions.map(({ label, field }) => (
        <FilterField
          key={field}
          isLoading={isLoading}
          filterValues={filterValues}
          filters={filters}
          setFilters={setFilters}
          field={field}
          label={label}
        />
      ))}
    </div>
  );
};
